<template>
  <v-autocomplete
    @update:search-input="isTyping = true" 
    @input="chosenPerson"
    v-model="model"
    :search-input.sync="searchQuery" 
    label="Search Person"
    :items="searchResult"
    item-text="Subject"
    item-value="OID"
    :hide-no-data="hideNoData"
    :no-data-text="noDataText"
    :loading="loading"
    prepend-icon="mdi-account"
    :menu-props="{ offsetY: true }"
    clearable
    return-object
    hint="At least 5 characters"
    :color="color"
  ></v-autocomplete>
</template>

<script>
import debounce from 'lodash/debounce'
import { API } from 'aws-amplify'

export default {
  name: 'search-person',
  props: {
    color: {
      type: String,
      default: 'blue'
    }
  },
  data() {
    return {
      model: null,
      searchQuery: null,
      isTyping: false,
      searchResult: [],
      loading: false,
      hideNoData: true,
      noDataText: '',
    }
  },
  watch: {
    searchQuery: debounce(function() {
      this.isTyping = false;
    }, 1000),
    isTyping: function(value) {
      if (!value && this.searchQuery && this.searchQuery.length > 5) {
        this.searchPerson(this.searchQuery)
        this.loading = true
      }
    }
  },
  methods: {
    chosenPerson() {
      const selectedPersons = this.model
      this.$emit('selectedPersons', selectedPersons)
      this.model = null
    },
    async searchPerson(query) {
      this.loading = true;
      try {
        const response = await API.get('negAppRestApi', '/proxy/get', {
          headers: {
            token: this.$store.state.user.LoginToken
          },
          queryStringParameters: {
            endpoint: `/${this.$store.state.user.ClientName}/search/person`,
            name: query
          }
        });
        
        const searchData = response.data;
        if(searchData && searchData.Count > 0) {
          this.searchResult = searchData.Data;
          this.hideNoData = true;
        } else {
          this.searchResult = [];
          this.hideNoData = false;
          this.noDataText = "No data found with this name";
        }
      } catch (error) {
        console.error('Person search error:', error);
        this.searchResult = [];
        this.hideNoData = false;
        this.noDataText = "An error has occurred in the system. Please try again.";
        this.$emit('searchError', error);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>